import {useState} from 'react'
import {useFormik} from 'formik'
import {useNavigate} from 'react-router-dom'
import {twofactor} from '../core/_requests'
import {useAuth} from '../core/Auth'

export function TwoFactor() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const {saveAuth, auth, currentUser} = useAuth()

  const initialValues = {
    code_1: '',
    code_2: '',
    code_3: '',
    code_4: '',
    code_5: '',
    code_6: '',
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      const code = Object.values(values).join('')

      if (code.length < 6) {
        setStatus('Código de validação incorreto.')
        setSubmitting(false)
        setLoading(false)
        return
      }

      try {
        const {data: twoFactorResponse} = await twofactor(code)

        if (auth && twoFactorResponse.validation) {
          saveAuth({
            access_token: auth.access_token,
            refreshToken: auth.refreshToken,
            twoFactorValidation: true,
          })

          navigate('/dashboard')
        } else {
          setStatus('Código de validação incorreto.')
        }
      } catch (error) {
        setStatus('Erro ao validar o código.')
      }

      setSubmitting(false)
      setLoading(false)
    },
  })

  const handleInput = (event, fieldIndex) => {
    const value = event.target.value
    formik.setFieldValue(`code_${fieldIndex}`, value ? value.slice(0, 1) : '')

    if (value.length === 1 && fieldIndex < 6) {
      const nextField = document.getElementById(`code_${fieldIndex + 1}`)

      nextField && nextField.focus()
    }
  }

  const handlePaste = (event) => {
    const paste = event.clipboardData.getData('text')

    console.log(paste)

    if (paste.length === 6) {
      const fields = paste.split('')

      // Criar um novo objeto de valores baseado nos campos colados
      const newValues = fields.reduce((acc, curr, index) => {
        acc[`code_${index + 1}`] = curr
        return acc
      }, {})

      // Atualizar todos os valores de uma vez
      formik.setValues({
        ...formik.values,
        ...newValues,
      })
    }
  }

  return (
    <form className='form w-100 mb-13' noValidate onSubmit={formik.handleSubmit}>
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Verificação em dois fatores</h1>
        <div className='text-muted fw-semibold fs-5 mb-5'>
          Verifique o código para autenticação enviado para
        </div>
        <div className='fw-bold text-dark fs-3'>{currentUser?.email}</div>
      </div>

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      <div className='mb-10'>
        <div className='fw-bold text-start text-dark fs-6 mb-1 ms-1'>
          Digite ou cole o código de verificação recebido
        </div>
        <div className='d-flex flex-wrap flex-stack'>
          {Array.from({length: 6}).map((_, index) => (
            <input
              key={index + 1}
              id={`code_${index + 1}`}
              type='text'
              name={`code_${index + 1}`}
              maxLength={1}
              className='form-control bg-transparent h-60px w-60px fs-2qx text-center mx-1 my-2'
              inputMode='numeric'
              autoComplete='off'
              onChange={(event) => handleInput(event, index + 1)}
              onPaste={handlePaste}
            />
          ))}
        </div>
      </div>

      <div className='d-flex flex-center'>
        <button id='submit' type='submit' className='btn btn-lg btn-primary fw-bold'>
          <span className='indicator-label'>Verificar</span>
        </button>
      </div>
    </form>
  )
}
